import React, { useState, useEffect } from 'react';
import axios from 'axios';
//logo
import LogoWhite from '../assets/img/balatlogo.png';
import { FaInstagram, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import Pobac from "../assets/img/pobaclogo.jpeg"

const Footer = () => {
  // Varsayılan numara (API gelene kadar veya hata durumunda)
  const [phone, setPhone] = useState("0530 110 93 83");
  const [rawPhone, setRawPhone] = useState("905301109383");

  useEffect(() => {
    const fetchPhone = async () => {
      try {
        const res = await axios.get("https://api.pinkhomebalat.com/api/public/whatsapp");
        if (res.data.whatsapp_num) {
          const num = res.data.whatsapp_num;
          setRawPhone(num); // Link için (905...)
          
          // Numarayı footer'da güzel formatta göstermek için ufak bir düzenleme
          // Eğer numara "905301109383" formatındaysa "0530 110 93 83" yapar
          let formatted = num.startsWith("90") ? "0" + num.substring(2) : num;
          formatted = formatted.replace(/(\d{4})(\d{3})(\d{2})(\d{2})/, "$1 $2 $3 $4");
          setPhone(formatted);
        }
      } catch (err) {
        console.error("Footer WP numarası çekilemedi.");
      }
    };
    fetchPhone();
  }, []);

  return (
    <footer id='iletisim' className='bg-primary py-12'>
      <div className='container mx-auto text-white flex flex-col md:flex-row justify-between items-start md:items-center gap-y-6'>
        {/* Logo */}
        <a href='https://share.google/bG29Od7QzuRyFZ8Lt' target='_blank' rel='noopener noreferrer'>
          <img className='w-[160px] md:w-[120px]' src={LogoWhite} alt='Logo'/>
        </a>

        {/* İletişim Bilgileri */}
        <div className='flex flex-col gap-y-2 text-white'>
          <a href='https://maps.google.com' target='_blank' rel='noopener noreferrer' className='flex items-center gap-x-2 hover:text-accent transition'>
            <FaMapMarkerAlt /> Balat, Akgül Sk. No:7, 34087 Fatih/İstanbul
          </a>
          
          {/* Dinamik Telefon Linki */}
          <a href={`tel:${rawPhone}`} className='flex items-center gap-x-2 hover:text-accent transition'>
            <FaPhone /> {phone}
          </a>

          <a href='https://www.instagram.com/pinkhome.balat/' target='_blank' rel='noopener noreferrer' className='flex items-center gap-x-2 hover:text-accent transition'>
            <FaInstagram /> @pinkhome.balat
          </a>
        </div>

        {/* Telif hakkı */}
        <span className='mt-4 md:mt-0'>© 2025. Tüm Hakları Korunmaktadır.</span>
        
        <a href='https://pobacsoftware.com' target='_blank' rel='noopener noreferrer'>
          <img className='w-[160px] md:w-[120px]' src={Pobac} alt='Logo'/>
        </a>
      </div>
    </footer>
  );
};

export default Footer;